/* PM search price-sort fix 2026-10-10 (search page only; loaded by sections/main-search.liquid).
   When sort_by=price-ascending|price-descending on /search, Shopify returns ~1000 loosely matched
   results ordered by price. This script fetches the relevance-ordered results (templates/search.pm-json.liquid,
   250/page, max 4 pages = 1000), keeps only relevant products, sorts them by price and renders cards via
   templates/product.pm-card.liquid (theme's own card-product snippet).
   Relevance rule (title + product type, case-insensitive, simple plural tolerance):
     terms = query words minus filler/stop words (inch, in, inches, the, for, with, and, a, an, of, to, ", etc.)
     word terms = terms containing a letter; number terms = pure numbers (e.g. 32, 1.28)
     tier 1: every word term AND every number term matches            (e.g. "vanity" + "32")
     tier 2: every word term matches                                 (numbers dropped)
     tier 3: any word term matches
     tier 4: nothing matched -> leave Shopify's own list untouched
   Relevance order (no sort_by) and all other sorts are never touched. */
(function () {
  if (!/^\/search\/?$/.test(location.pathname.replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/)/i, ''))) return;
  var STOP = ('inch inches in the for with and a an of to x by on or at from is it this that your our "' +
    ' ″ ” in. inch. " ft feet mm cm pc pcs piece set').split(/\s+/);
  var PER_PAGE = 16, MAX_PAGES = 4, busy = 0;
  function stem(w) {
    if (w.length > 4 && /ies$/.test(w)) return w.slice(0, -3) + 'y';
    if (w.length > 4 && /(ch|sh|x|z|ss)es$/.test(w)) return w.slice(0, -2);
    if (w.length > 3 && /s$/.test(w) && !/ss$/.test(w)) return w.slice(0, -1);
    return w;
  }
  function toks(s) {
    return (s || '').toLowerCase().replace(/[″”“"]/g, ' " ').match(/\d+(?:\.\d+)?|[a-z\u00c0-\u024f]+(?:'[a-z]+)?|"/g) || [];
  }
  function terms(q) {
    var seen = {}, out = { words: [], nums: [] };
    toks(q).forEach(function (t) {
      if (STOP.indexOf(t) > -1 || seen[t]) return; seen[t] = 1;
      if (/^\d+(\.\d+)?$/.test(t)) out.nums.push(t); else if (t.length > 1) out.words.push(stem(t));
    });
    return out;
  }
  function hay(p) {
    var ts = toks((p.t || '') + ' ' + (p.ty || ''));
    return { stems: ts.map(stem), raw: ts };
  }
  function wordHit(h, w) {
    for (var i = 0; i < h.stems.length; i++) {
      var s = h.stems[i];
      if (s === w || (w.length >= 4 && s.indexOf(w) === 0 && s.length - w.length <= 3)) return true;
    }
    return false;
  }
  function numHit(h, n) { return h.raw.indexOf(n) > -1; }
  /* v2 2026-10-10 tighter rule (head noun + accessory exclusion), falls back to v1 tiers */
  var ACC = ['part', 'seat', 'drain', 'adapter', 'adaptor', 'knob', 'cap', 'button', 'pull', 'cartridge', 'hose', 'plate', 'cover', 'escutcheon', 'kit', 'valve', 'handlekit'];
  /* CR-M35d 2026-10-15: support / bracket / leg count as accessory only when the head noun is missing from the title
     ("Slik Floor sink support" for vanity) or sits right before it ("Vanity Leg Set"); "Freestanding bathtub, brushed nickel legs",
     "Sink and Semi-Pedestal Leg Combination" and "Cabinet with Basin, U Legs" stay. */
  var ACC2 = ['support', 'bracket', 'leg'];
  var ACC_TYPE = /\b(parts?|accessor(y|ies)|repair|replacement)\b/i;
  function headHit(h, w) {
    for (var i = 0; i < h.stems.length; i++) { var s = h.stems[i]; if (s === w || (w.length >= 3 && s.indexOf(w) > -1)) return true; }
    return false;
  }
  function accTitle(t) {
    return (t || '').toLowerCase().replace(/\s(with|w\/|including|incl\.?)\s[\s\S]*$/, ' ')
      .replace(/pull[\s-]?(down|out)/g, 'pulldown').replace(/handle[\s-]+kit/g, 'handlekit')
      .replace(/(center|centre|end|left|right|hand|reversible|dual|side)[\s-]+drain/g, ' ');
  }
  function isAcc(p, head, qset) {
    if (ACC_TYPE.test(p.ty || '') && !/part|accessor|repair|replacement/.test(qset.raw)) return true;
    var tt = toks(accTitle(p.t)).map(stem), ty = toks(p.ty).map(stem), all = tt.concat(ty);
    var t = (p.t || '').toLowerCase(), fi = t.search(/\sfor\s/), before = fi > -1 ? t.slice(0, fi) : t;
    var headFirst = toks(before).map(stem).some(function (s) { return s === head || (head.length >= 3 && s.indexOf(head) > -1); });
    if (fi > -1 && !headFirst) return true; /* "Cover Plate for Kitchen Faucet", "Seat for WASHLET" */
    var hi = -1;
    for (var k = 0; k < tt.length; k++) { if (tt[k] === head || (head.length >= 3 && tt[k].indexOf(head) > -1)) { hi = k; break; } }
    for (var j = 0; j < ACC2.length; j++) {
      var ai = tt.indexOf(ACC2[j]);
      if (ai < 0 || qset.words.indexOf(ACC2[j]) > -1 || ACC2[j] === head) continue;
      if (hi < 0 || (ai > hi && ai - hi <= 2)) return true;
    }
    for (var i = 0; i < ACC.length; i++) {
      var a = ACC[i];
      if (all.indexOf(a) < 0 || qset.words.indexOf(a) > -1 || a === head) continue;
      if (a === 'seat' && headFirst && tt.indexOf(head) > -1) continue; /* "WASHLET ... bidet seat" is the product */
      return true;
    }
    return false;
  }
  /* followup 2026-10-15: vanity queries skip lighting (Dainolite vanity lights, sconces, bath bars) unless the query mentions light/lighting.
     Mirrors and medicine cabinets (incl. lighted / LED mirrors) are never treated as lighting. */
  var LIGHT_Q = /(^|\s)(light|lights|lighting|lighted|lamp|sconce|sconces|fixture|fixtures|led)(\s|$)/i;
  var LIGHT_T = /\b(vanity[\s-]+lights?|\d+[\s-]*lights?|sconces?|bath[\s-]*bars?|light[\s-]+fixtures?|led|lighting|pendant|chandelier|\d+(\.\d+)?\s*w|colou?r[\s-]+changing|\d+\s*lts?|cct|lumens?|incandescent|halogen)\b/i;
  var LIGHT_TY = /\b(lighting|lights?|sconces?|pendants?|chandeliers?)\b/i;
  var MIRROR = /\b(mirrors?|medicine[\s-]+cabinets?)\b/i;
  function isLight(p) {
    var t = (p.t || '').replace(/\s(with|w\/|including|incl\.?)\s[\s\S]*$/i, ' '), ty = p.ty || '';
    if (MIRROR.test(t) || MIRROR.test(ty)) return false;
    return LIGHT_TY.test(ty) || LIGHT_T.test(t);
  }
  function pick(items, T) {
    if (T.words.some(function (w) { return w === 'vanity' || w === 'vanitie'; }) && !LIGHT_Q.test(T.words.join(' '))) {
      var nl = items.filter(function (p) { return !isLight(p); });
      if (nl.length) items = nl;
    }
    var H = items.map(hay);
    if (T.words.length) {
      var head = T.words[T.words.length - 1], qset = { words: T.words, raw: T.words.join(' ') };
      var base = items.filter(function (p, i) { return headHit(H[i], head) && !isAcc(p, head, qset); });
      var idx = items.map(function (p, i) { return i; }).filter(function (i) { return headHit(H[i], head) && !isAcc(items[i], head, qset); });
      /* product-type head: if >=4 candidates have a type whose last word is the head noun (e.g. type "Freestanding Bathtubs" for "tub"), keep only those (drops towel stands, tub fillers) */
      var th = idx.filter(function (i) { var ty = toks(items[i].ty).map(stem), l = ty[ty.length - 1] || ''; return l === head || (head.length >= 3 && l.indexOf(head) > -1); });
      if (th.length >= 4) { idx = th; base = th.map(function (i) { return items[i]; }); }
      var allw = idx.filter(function (i) { return T.words.every(function (w) { return wordHit(H[i], w) || headHit(H[i], w); }); });
      var alln = allw.filter(function (i) { return T.nums.every(function (n) { return numHit(H[i], n); }); });
      if (T.nums.length && alln.length) return alln.map(function (i) { return items[i]; });
      if (allw.length >= 4 || (allw.length && allw.length === base.length)) return allw.map(function (i) { return items[i]; });
      if (base.length) return base;
    }
    return pickV1(items, T, H);
  }
  function pickV1(items, T, H) {
    var tiers = [];
    if (T.words.length && T.nums.length) tiers.push(function (h) { return T.words.every(function (w) { return wordHit(h, w); }) && T.nums.every(function (n) { return numHit(h, n); }); });
    if (T.words.length) tiers.push(function (h) { return T.words.every(function (w) { return wordHit(h, w); }); });
    if (T.words.length > 1) tiers.push(function (h) { return T.words.some(function (w) { return wordHit(h, w); }); });
    if (!T.words.length && T.nums.length) tiers.push(function (h) { return T.nums.every(function (n) { return numHit(h, n); }); });
    for (var k = 0; k < tiers.length; k++) {
      var r = items.filter(function (p, i) { return tiers[k](H[i]); });
      if (r.length) return r;
    }
    return null;
  }
  function getJSON(u) { return fetch(u, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); }).then(JSON.parse); }
  function done(list) { if (list) list.removeAttribute('data-pm-pss'); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function pager(cur, pages, base) {
    if (pages < 2) return '';
    function href(n) { var u = new URL(base); u.searchParams.set('page', n); return esc(u.pathname + u.search); }
    var h = '<nav class="pagination" role="navigation" aria-label="Pagination"><ul class="pagination__list list-unstyled flex items-center flex-wrap justify-center" role="list">';
    if (cur > 1) h += '<li><a href="' + href(cur - 1) + '" class="pagination__item pagination__item--previous pagination__item-arrow motion-reduce"><span>Previous</span></a></li>';
    var shown = {}; [1, 2, 3, cur - 1, cur, cur + 1, pages].forEach(function (n) { if (n >= 1 && n <= pages) shown[n] = 1; });
    var last = 0;
    for (var n = 1; n <= pages; n++) {
      if (!shown[n]) continue;
      if (n - last > 1) h += '<li><span class="pagination__item">…</span></li>';
      h += n === cur ? '<li><a role="link" aria-disabled="true" class="pagination__item pagination__item--current background-2" aria-current="page" aria-label="Page ' + n + '">' + n + '</a></li>'
        : '<li><a href="' + href(n) + '" class="pagination__item" aria-label="Page ' + n + '">' + n + '</a></li>';
      last = n;
    }
    if (cur < pages) h += '<li><a href="' + href(cur + 1) + '" class="pagination__item pagination__item--next pagination__item-arrow motion-reduce"><span>Next</span></a></li>';
    return h + '</ul></nav>';
  }
  function run() {
    var url = new URL(location.href), sort = url.searchParams.get('sort_by') || '';
    var list = document.getElementById('ProductsList');
    if (!/^price-(ascending|descending)$/.test(sort) || !list) { done(list); return; }
    var q = url.searchParams.get('q') || '', T = terms(q);
    if (!T.words.length && !T.nums.length) { done(list); return; }
    var my = ++busy, cur = Math.max(1, parseInt(url.searchParams.get('page') || '1', 10) || 1);
    var ju = new URL(url); ju.searchParams.delete('sort_by'); ju.searchParams.delete('page'); ju.searchParams.delete('_cb');
    ju.searchParams.set('view', 'pm-json');
    var all = [];
    /* CR-M35d 2026-10-23: fetch page 1, then pages 2..MAX in parallel (was serial; ~7-8 s for 1000 items hit the 8 s CSS reveal) */
    function pageUrl(n) { var u = new URL(ju); u.searchParams.set('page', n); return u.toString(); }
    function page(n) {
      return getJSON(pageUrl(n)).then(function (d) {
        var last = Math.min(d.pages || 1, MAX_PAGES), rest = [];
        for (var k = n + 1; k <= last; k++) rest.push(getJSON(pageUrl(k)).catch(function () { return { items: [] }; }));
        return Promise.all(rest).then(function (ds) {
          all = all.concat(d.items || []);
          ds.forEach(function (x) { all = all.concat(x.items || []); });
        });
      });
    }
    page(1).then(function () {
      if (my !== busy) return;
      var seen = {}; all = all.filter(function (p) { if (seen[p.h]) return false; return (seen[p.h] = 1); });
      var rel = pick(all, T);
      if (!rel) { done(list); return; }
      var dir = sort === 'price-descending' ? -1 : 1;
      rel = rel.map(function (p, i) { p.i0 = i; return p; }).sort(function (a, b) { return (a.p - b.p) * dir || a.i0 - b.i0; });
      var pages = Math.ceil(rel.length / PER_PAGE); if (cur > pages) cur = pages;
      var slice = rel.slice((cur - 1) * PER_PAGE, cur * PER_PAGE);
      return Promise.all(slice.map(function (p) {
        return fetch('/products/' + encodeURIComponent(p.h) + '?view=pm-card', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
      })).then(function (cards) {
        if (my !== busy) return;
        var html = cards.filter(function (c) { return c.indexOf('f-column') > -1; }).join('');
        if (!html) { done(list); return; }
        list.innerHTML = html;
        var cont = document.getElementById('ProductGridContainer');
        var old = cont && cont.querySelector('.pagination');
        var base = new URL(url); base.searchParams.delete('_cb');
        var ph = pager(cur, pages, base.toString());
        if (old) old.outerHTML = ph || ''; else if (ph && cont) cont.insertAdjacentHTML('beforeend', ph);
        var pc = document.getElementById('ProductCount');
        if (pc) { var t = pc.textContent; pc.textContent = /\d[\d,]*/.test(t) ? t.replace(/\d[\d,]*/, rel.length) : rel.length + ' results'; }
        done(list);
      });
    }).catch(function () { if (my === busy) done(list); });
  }
  function init() {
    run();
    var cont = document.getElementById('ProductGridContainer');
    if (cont && window.MutationObserver) new MutationObserver(function (m) {
      for (var i = 0; i < m.length; i++) for (var j = 0; j < m[i].addedNodes.length; j++)
        if (m[i].addedNodes[j].id === 'ProductsList') { run(); return; }
    }).observe(cont, { childList: true });
    window.addEventListener('popstate', function () { setTimeout(run, 50); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
